import { Drawer, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { SidebarFooter } from './SidebarFooter';
import SidebarHeader from './SidebarHeader';
import { SidebarMenu } from './SidebarMenu';
import type { IMenuItem } from './types';

interface ISidebarProps {
  open: boolean;
  onClose?: () => void; // needed for mobile
  fetchedMenuItems: IMenuItem[];
}

export const Sidebar = ({ open, onClose, fetchedMenuItems }: ISidebarProps) => {
  const { pathname } = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const menu = useMemo(() => {
    return fetchedMenuItems.map((item) => ({
      ...item,
      isActive: pathname === item.link,
    }));
  }, [fetchedMenuItems, pathname]);

  return (
    <Drawer
      variant={isMobile ? 'temporary' : 'persistent'}
      open={open}
      onClose={onClose}
      anchor="left"
      sx={{
        width: open ? 260 : 0,
        flexShrink: 0,
        transition: 'width 0.3s ease',

        '& .MuiDrawer-paper': {
          width: 260,
          boxSizing: 'border-box',
          overflowX: 'hidden',
          // hide paper completely when closed on desktop
          transform: !open && !isMobile ? 'translateX(-260px)' : 'translateX(0)',
          transition: 'transform 0.3s ease',
        },
      }}
    >
      <SidebarHeader />
      <SidebarMenu menu={menu} />
      <SidebarFooter />
    </Drawer>
  );
};
